// Base Styles
import colors from "assets/mavric-theme/base/colors";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";

const { info, inputBorderColor, text } = colors;
const { size } = typography;
const { borderWidth } = borders;

const input = {
  styleOverrides: {
    root: {
      fontSize: size.sm,
      color: text.main,

      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `${borderWidth[1]} solid ${inputBorderColor}`,
      },

      "&:before": {
        borderColor: inputBorderColor,
      },

      "&:after": {
        borderColor: info.main,
      },
    },
  },
};

export default input;
